import { cloneDeep } from 'lodash';
import { getPatchedDataSchema } from '@tencent/data-schema-core';
import { schemaOfUtilsForUser } from '@tencent/wuji-utils';
const getUtilsSchema = () => {
    const schema = cloneDeep(schemaOfUtilsForUser);
    schema.id = 'utils';
    // 过滤掉 Lodash 的方法
    schema.methods = schema?.methods?.filter((item) => ![
        'cloneDeep',
        'isEqual',
        'forEach',
        'fromPairs',
        'toPairs',
        'pick',
        'omit',
        'get',
        'mapValues',
        'orderBy',
        'filterData',
        'translateFilterToStr',
    ].includes(item.id));
    return getPatchedDataSchema(schema);
};
export default getUtilsSchema;
